import axios from 'axios'

// One place for a full client sign-out. Partial clears (auth without user,
// member still in the Vue store, leftover Authorization cookie) are what
// let Register proceed while GraphQL createRegistration goes out anonymous.

function expireAuthCookie() {
	document.cookie = 'Authorization=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
}

export function clearClientSession() {
	window.localStorage.removeItem('user')
	window.localStorage.removeItem('email')
	window.localStorage.removeItem('token')
	window.localStorage.removeItem('auth')
	window.user = null
	expireAuthCookie()
	delete axios.defaults.headers.common['Authorization']
}

export function signOutClient(user) {
	clearClientSession()
	if (!user) return
	if (Object.prototype.hasOwnProperty.call(user, 'value')) user.value = {}
	else {
		user.member = undefined
		user.registration = undefined
		user.cart = undefined
		user.loading = false
	}
}
